import {
  createBrowserRouter,
  Navigate,
  Outlet,
  useNavigation
} from "react-router-dom";
import Login, { loginAction } from "./components/auth/Login";
import MainLayout, { authLoader, logOutAction } from "./components/main/Main";
import appRoutes from "./components/main/AppRoutes";
import { appTitle } from "./components/common/functions";
import { useAuthStore } from "./components/main/authStore";
import { useEffect } from "react";
import Resize from "./components/common/Resize";
import GlobalLoader from "./components/common/Loader";
import ForgetPassword, { forgetPasswordAction } from "./components/auth/ForgetPassword";
import ChangePassword, { changePasswordAction } from "./components/auth/ChangePassword";
import UploadProgressModal from "./components/common/UploadProgressModal";
import GlobalModal from "./components/main/GlobalModal";
export const router = createBrowserRouter([{
    element: <RootLayout/>, 
    children: [
    {
        path: "/Login",
        element: <Login/>, 
        action: loginAction, 
        children: [{ path: "*", element: <Navigate to = ".." replace/>}]
    },
    {
        path: "/ForgetPassword",
        element: <ForgetPassword/>,
        action: forgetPasswordAction, 
        children: [{ path: "*", element: <Navigate to = ".." replace/>}]
    },
    {
        path: "/ChangePassword",
        element: <ChangePassword/>, 
        action: changePasswordAction, 
        children: [{ path: "*", element: <Navigate to = ".." replace/>}]
    },
    {
        path: "/",
        loader: authLoader,
        HydrateFallback: () => 
            <div className = "app-loading">
                Content Loading...
            </div>
        ,
        element: <MainLayout/>,
        action: logOutAction, 
        children: [
            {index: true, element: <></>}, 
            ...appRoutes({}).map(value => ({
                path: value.path.split("/")[0],
                element: <Combine value = {value}/>,
                id: value.id,
                loader: value.loader, 
                action: value.action, 
                shouldRevalidate: value.shouldRevalidate, 
                children: value.children ?? []
            })),
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    },
    { path: "*", element: <Navigate to = ".." replace/>}
]}]);

function Combine({value}){
    const user = useAuthStore().user;
    useEffect(() => {
        document.title = value.title;
        return () => {
            document.title = appTitle;
        };
    }, [value.title]);
    return <>
    <div className = "cssTab">
        <div className = "cssHeader" style = {{background: user.userTheme}}>
            <span>
                <Resize/>
                {value.title}
            </span>
        </div>
        <div className = "cssContent">
            {value.element ?? <Outlet/>}
        </div>
    </div>
    </>
}

function RootLayout(){
const navigation = useNavigation();
const isLoading = navigation.state !== "idle";
return (
    <>
        {isLoading && <GlobalLoader/>}
        <Outlet/>
        <UploadProgressModal/>
        <GlobalModal/>
    </>
)
}